import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Tooltip, Drawer, Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { constant } from '../../../../Utils/constants';
import translation from '../../../../../../commons/translation';
import StyledTable from "../../../../../../commons/styles/table";
import {
  API_APPCONFIGATTACHMENTS,
  IPAddress,
  API_MASTERWORKORDERS
} from '../../../../../../commons/api';

const { Option } = Select;

const FileBase64 = (props) => {
  const [viewFilesList, setViewFilesList] = useState(false);
  const myRef = useRef();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (props.Attachments && Array.isArray(props.Attachments)) {
      setFiles(props.Attachments);
    }
  }, [props.Attachments]);

  const handleChange4 = (e) => {
    let selectedFiles = e.target.files;
    const formData = new FormData();
    let filesInfo = [];

    for (const file of selectedFiles) {
      formData.append('files', file);
      let fileInfo = {
        Name: file.name,
        AttachmentType: file.type,
        Size: Math.round(file.size / 1000) + ' kB'
      };
      filesInfo.push(fileInfo);
      props.fileUpload(filesInfo, 'Attachments', file, props.name);
    }
  };

  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current.click();
    } else {
      setViewFilesList(true);
    }
  };

  const columns = [
    {
      title: 'File',
      dataIndex: 'Name',
      key: 'Name',
      align: 'center',
      render: (text, record) => (
        <span>
          {record && record.AliasName ? (
            <Tooltip placement="top" title="View">
              <div style={{ marginLeft: '-25px' }}>
                <a
                  href={`${IPAddress.LOCAL}${API_APPCONFIGATTACHMENTS.AppConfigAttachments}/${record.AliasName}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {text}
                </a>
              </div>
            </Tooltip>
          ) : (
            <Tooltip placement="top" title="View will enable after submit">
              <div style={{ marginLeft: '-25px' }}>{text}</div>
            </Tooltip>
          )}
        </span>
      )
    },
    {
      title: 'Action',
      width: '600',
      align: 'center',
      render: (text, record) => (
        <span>
          {record && record.AliasName ? (
            <Tooltip placement="top" title="Download">
              <div style={{ marginLeft: '-25px' }}>
                <a
                  href={`${IPAddress.LOCAL}${API_MASTERWORKORDERS.DOWNLOADFILE}?Id=${record.Id}`}
                >
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          ) : (
            <Tooltip placement="top" title="Download will enable after submit">
              <div style={{ marginLeft: '-25px' }}>
                <DownloadOutlined />
              </div>
            </Tooltip>
          )}
        </span>
      )
    }
  ];

  return (
    <>
      <Select
        placeholder={translation(props.translationCache, constant.PleaseSelect)}
        onSelect={handleClick}
        style={{ width: '85%' }}
      >
        <Option key={'View Attachments'} value={'View Attachments'}>
          {translation(props.translationCache, constant.ViewAttachments)}
        </Option>
        <Option
          disabled={props.disableAdd}
          key={'Add New Attachments'}
          value={'Add New Attachments'}
        >
          {translation(props.translationCache, constant.AddNewAttachments)}
        </Option>
      </Select>
      <input
        type="file"
        ref={myRef}
        onChange={handleChange4}
        style={{ display: 'none' }}
      />
      <Drawer
        title="Uploaded Files"
        open={viewFilesList}
        width={600}
        onOk={() => setViewFilesList(false)}
        onClose={() => setViewFilesList(false)}
      >
        <StyledTable size="small"
          columns={columns}
          dataSource={files} // Use the files state here
        />
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(FileBase64);